/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.alert[_ngcontent-%COMP%]{width:100%;max-width:380px;margin:0 auto 1rem}"];
export { styles as styles };
